<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form-model ref="form" :model="model" slot="detail">
        <a-row :disabled="formDisabled">
          <a-col :span="12">
            <a-form-model-item
              :label="language['eletronicSigned.processNo']"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              ><!-- prop="applicationCode"-->
              <a-input v-model="model.process_no" placeholder="" :disabled="isDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :label="language['eletronicSigned.startTime']"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-date-picker
                style="width: 100%"
                :disabled="isDisabled"
                v-model="model.start_time_java"
                :format="dateFormat"
                :getCalendarContainer="(node) => node.parentNode"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
             <a-form-model-item
               label="紧急程度"
               :labelCol="labelCol"
               :wrapperCol="wrapperCol">
               <a-radio-group v-model="model.urgent_degree" :disabled="isDisabled">
                 <a-radio value="特急件">特急件</a-radio>
                 <a-radio value="急件">急件</a-radio>
                 <a-radio value="一般件">一般件</a-radio>
               </a-radio-group>
             </a-form-model-item>
           </a-col>-->
        </a-row>
        <a-tabs
          @change="changeTabs"
          default-active-key="1"
          size="large"
          :tab-bar-style="{ marginBottom: '24px', paddingLeft: '16px' }"
        >
          <a-tab-pane
            loading="true"
            :tab="tabName"
            key="1"
            :style="
              innerFullscreen === false
                ? setEdit === true
                  ? `max-height: 32vh;overflow:scroll`
                  : `max-height: 45vh;overflow:scroll`
                : setEdit === true
                ? `max-height: 60vh;overflow:scroll`
                : `max-height: 65vh;overflow:scroll`
            "
          >
            <div v-if="processModel.applicationCode === 'env_audit'">
              <!--<env-form ref="realForm" ></env-form>-->
              <danger-sign-form ref="applicationModel" :formNo="ipsys_aid" :formCode="formCode"></danger-sign-form>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              <!--<a-empty>111111</a-empty>-->
              <!--<a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-model-item>
              <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-model-item>
              <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-model-item>-->
            </div>
            <div v-if="processModel.applicationCode === 'ipsys'">
              <div
                v-if="
                  processModel.modelCode === 'IpsTrademarkUserReport' ||
                  processModel.modelCode === 'IpsTrademarkUserReportC'
                "
              >
                <s-tm-apply
                  ref="applicationModel"
                  :apply-no="ipsys_aid"
                  :pageType="pageType"
                  @ok="$emit('ok')"
                ></s-tm-apply>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" />
              </div>
              <div v-if="processModel.modelCode === 'IpsTrademarkApplyRegister'">
                <tm-apply :idFormNo="ipsys_aid" :pageType="pageType" @ok="$emit('ok')"></tm-apply>
              </div>
              <div v-if="processModel.modelCode === 'IpsTrademarkRetrieve'">
                <tm-retrieve :idFormNo="ipsys_aid" :pageType="pageType" @ok="$emit('ok')"></tm-retrieve>
              </div>
            </div>
            <div v-if="processModel.applicationCode === 'ipsystur'">
              <!--技术案件提案 -->
              <div v-if="processModel.modelCode == 'IpsTechnologProposal'">
                <request-proposal :idFormNo="ipsys_aid" @handleCloseModal="$emit('ok')" />
              </div>
              <!--技术揭露提案布局评估 -->
              <div
                v-if="
                  processModel.modelCode === 'IpsTechnologyDisclosureEvaluate' ||
                  processModel.modelCode == 'IpsTechnologyDisclosureEvaluateB'
                "
              >
                <layout-evaluation :idFormNo="ipsys_aid" @handleCloseModal="$emit('ok')" />
              </div>
            </div>
            <div v-if="processModel.applicationCode === 'ipsystbs'">
              <!--技术营业秘密 -->
              <div v-if="processModel.modelCode === 'IpsTechnicalBusinessSecrets'">
                <business-secrets :idFormNo="ipsys_aid" @handleCloseModal="$emit('ok')" />
              </div>
            </div>
            <div v-if="processModel.applicationCode === 'envinfo'">
              <div v-if="processModel.modelCode === 'trashForm'">
                <epi-trash-sign-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></epi-trash-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'waterForm'">
                <epi-water-sign-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></epi-water-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'gasForm'">
                <epi-gas-sign-form ref="applicationModel" :formNo="ipsys_aid" :formCode="formCode"></epi-gas-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
              <div v-if="processModel.modelCode === 'wasteWaterForm'">
                <epi-waste-water-sign-form :formNo="ipsys_aid" :formCode="formCode"></epi-waste-water-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
              <div v-if="processModel.modelCode === 'cfForm'">
                <epi-deter-sign-form :formNo="ipsys_aid" :formCode="formCode"></epi-deter-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
            </div>

            <div v-if="processModel.applicationCode === 'esg'">
              <div
                v-if="processModel.modelCode === 'esg_kpiForm_outLeader' || processModel.modelCode === 'esg_kpiForm'"
              >
                <esg-kpi-sign-form
                  ref="realForm"
                  :disabled="true"
                  :formCode="formCode"
                  :kpi-sign-no="ipsys_aid"
                ></esg-kpi-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
              <div
                v-else-if="
                  processModel.modelCode === 'esg_kpiDisForm' ||
                  processModel.modelCode === 'esg_kpiDisBgChange' ||
                  processModel.modelCode === 'esg_kpiDisBuChange' ||
                  processModel.modelCode === 'esg_kpiDisBgCancle' ||
                  processModel.modelCode === 'esg_kpiDisBuCancle'
                "
              >
                <esg-kpi-dis-sign-form
                  ref="realForm"
                  :disabled="true"
                  :formCode="formCode"
                  :formNo="ipsys_aid"
                  :menuType="'waitMenu'"
                ></esg-kpi-dis-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
            </div>

            <div v-if="processModel.applicationCode === 'sweep'">
              <!-- <epi-water-sign-form :formNo="ipsys_aid" :formCode="formCode"></epi-water-sign-form>-->
              <sweepsys-danger-sign-form
                ref="applicationModel"
                :formNo="ipsys_aid"
                :formCode="formCode"
              ></sweepsys-danger-sign-form>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
            </div>

            <div v-if="processModel.applicationCode === 'labor'">
              <div v-if="processModel.modelCode === 'labor_change'">
                <labor-change-manage-sign-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                  :disabled="true"
                  :detailDisabled="disabled"
                  :disabled-evaluate="false"
                  @isAgree="isAgree"
                  :order-no="orderNo"
                  :task-code="taskCode"
                ></labor-change-manage-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'labor_change_close'">
                <labor-change-manage-sign-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                  :disabled="true"
                  :disabled-evaluate="true"
                  @isAgree="isAgree"
                  :order-no="orderNo"
                  :task-code="taskCode"
                ></labor-change-manage-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
            </div>

            <div v-if="processModel.applicationCode === 'cst'">
              <div v-if="processModel.modelCode === 'cst_apply'">
                <cst-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_delay'">
                <cst-delay-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-delay-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_report'">
                <cst-report-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-report-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_night'">
                <cst-night-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-night-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_survey'">
                <cst-survey-check-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-survey-check-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_check'">
                <cst-survey-check-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :taskCode="taskCode"
                  :formCode="formCode"
                ></cst-survey-check-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_interrupt'">
                <cst-interrupt-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-interrupt-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_interrupt_confirm'">
                <cst-interrupt-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-interrupt-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_interrupt_recovery'">
                <cst-interrupt-request-order-form-sign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></cst-interrupt-request-order-form-sign>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_flame'">
                <cst-fire-request-order-sign-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                  :disabled="disabled"
                  @isAgree="isAgree"
                ></cst-fire-request-order-sign-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_gas'">
                <cst-gas-request-order-sign-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                  :disabled="disabled"
                  @isAgree="isAgree"
                />
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_exception'">
                <cst-not-started-exception-sign-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                  :disabled="disabled"
                  @isAgree="isAgree"
                />
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div
                v-else-if="
                  processModel.modelCode === 'cst_high' ||
                  processModel.modelCode === 'cst_hoisting' ||
                  processModel.modelCode === 'cst_confined_space' ||
                  processModel.modelCode === 'cst_temporary_electricity'
                "
              >
                <special-work-sign-modal
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                  :disabled="disabled"
                />
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
              <div v-else-if="processModel.modelCode === 'cst_carry'">
                <CstDeviceCarryFormSign
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                  :disabled="disabled"
                />
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-model-item>
              </div>
            </div>

            <div v-if="processModel.applicationCode === 'food'">
              <div v-if="processModel.modelCode === 'AuditWorkflow'">
                <audit-workflow-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></audit-workflow-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
              <div v-if="processModel.modelCode === 'PutOnRecordWorkflow'">
                <put-on-record-workflow-form
                  ref="applicationModel"
                  :formNo="ipsys_aid"
                  :formCode="formCode"
                ></put-on-record-workflow-form>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
            </div>
            <div v-if="processModel.applicationCode === 'showroom_platform'">
              <div v-if="processModel.modelCode === 'showroom_order'">
                <showroom-order-sign-details ref="applicationModel" :formNo="ipsys_aid" :formCode="formCode" />
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            :tab="language['eletronicSigned.fileUrls']"
            key="2"
            v-if="
              processModel.applicationCode === 'ipsys' &&
              (model.task_code === 'ApproveTask8' || model.task_code === 'ApproveTask9') &&
              1 === 0
            "
            :style="
              innerFullscreen === false
                ? setEdit === true
                  ? `max-height: 32vh;overflow:scroll`
                  : `max-height: 45vh;overflow:scroll`
                : setEdit === true
                ? `max-height: 60vh;overflow:scroll`
                : `max-height: 65vh;overflow:scroll`
            "
            ><!--v-if="testfile.length>0"-->
            <a-col :span="24">
              <p style="color: red">{{ language['eletronicSigned.fileUrlsPrompt'] }}</p>
              <!--商標已使用方式：（附照片或擷圖)-->
              <a-form-model-item
                :label="language['eletronicSigned.fileUrls']"
                required
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
              >
                <!--<j-image-upload class="avatar-uploader" text="上传" v-model="model.avatar"></j-image-upload>-->
                <!--<j-upload file-type="file" :value="model.avatar" @change="handleChange" disabled="disabled"></j-upload>-->
                <!--<j-file-pop ref="filePop" @ok="handleChange" />-->
                <!--<j-upload v-model="fileUrls" :disabled="fileAttribute.fileDisabled"></j-upload>-->
                <j-upload
                  upload-source="ipsys"
                  @change="handleChange"
                  :customName="true"
                  bizPath="null"
                  :multiple="fileAttribute.fileMultiple"
                  :disabled="model.task_code !== 'ApproveTask8'"
                  v-model="fileUrls"
                ></j-upload>
                <!--:disabled="fileAttribute.fileDisabled"-->
                <!--model.task_code==='ApproveTask8'-->
              </a-form-model-item>
            </a-col>
          </a-tab-pane>
          <a-tab-pane
            :tab="singTableName"
            key="3"
            :style="
              innerFullscreen === false
                ? setEdit === true
                  ? `max-height: 32vh;overflow:scroll`
                  : `max-height: 45vh;overflow:scroll`
                : setEdit === true
                ? `max-height: 60vh;overflow:scroll`
                : `max-height: 65vh;overflow:scroll`
            "
          >
            <a-card :loading="loading" :bordered="false" :title="language['eletronicSigned.signList']">
              <a-table
                size="middle"
                rowKey="id"
                :columns="columns"
                :pagination="false"
                :dataSource="dataSource"
                :loading="loading"
              >
                <span slot="approveResult" slot-scope="text, record">
                  {{
                    text === 'Cancel'
                      ? language['eletronicSigned.termination']
                      : langCode === 'zh_CN' || langCode === 'zh_TW'
                      ? record.actionTextLocalLang
                      : record.actionTextEn
                  }}
                </span>
              </a-table>
            </a-card>
            <a-card :loading="loading" :bordered="false" :title="language['eletronicSigned.signPerson']">
              <a-table
                :columns="approverColumns"
                size="middle"
                :data-source="approverData"
                :pagination="false"
                :loading="loading"
              ></a-table>
            </a-card>
          </a-tab-pane>
          <a-tab-pane
            :tab="language['eletronicSigned.processChart']"
            key="4"
            :style="
              innerFullscreen === false
                ? setEdit === true
                  ? `max-height: 32vh;overflow:scroll`
                  : `max-height: 45vh;overflow:scroll`
                : setEdit === true
                ? `max-height: 60vh;overflow:scroll`
                : `max-height: 65vh;overflow:scroll`
            "
          >
            <img style="width: 100%" :src="getProcessChart()" />
          </a-tab-pane>
        </a-tabs>
        <a-card
          :bordered="false"
          :title="
            processModel.applicationCode === 'ipsys' && model.task_code === 'ApproveTask8'
              ? ''
              : language['eletronicSigned.signOpinion']
          "
          v-if="urlType == 'todoProcess'"
        >
          <div v-if="processModel.applicationCode === 'ipsys'">
            <a-row v-if="!(model.task_code === 'ApproveTask8')">
              <a-textarea v-model="model.comments"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <!--<a-button style="color: blue;" @click="agree" v-if="model.task_code==='ApproveTask8'">{{language['eletronicSigned.sendOut']}}</a-button>-->
              <a-button
                style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px"
                @click="agree"
                v-if="!(model.task_code === 'ApproveTask8')"
                >{{ language['eletronicSigned.agree'] }}</a-button
              >
              <a-button
                style="color: blue; left: 20px; padding-left: 30px; padding-right: 30px"
                @click="agreeAndNext"
                v-if="!(model.task_code === 'ApproveTask8')"
                >{{ language['eletronicSigned.agreeAndNext'] }}</a-button
              >
              <a-button
                style="color: red; left: 40px; padding-left: 30px; padding-right: 30px"
                @click="reject"
                v-if="!(model.task_code === 'ApproveTask8')"
                >{{ language['eletronicSigned.reject'] }}</a-button
              >
            </div>
          </div>
          <div v-else-if="processModel.modelCode === 'cst_check' && model.task_code === 'Applicant'">
            <a-row>
              <a-textarea v-model="model.comments" maxlength="200"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <a-button
                style="color: blue; left: 20px; padding-left: 30px; padding-right: 30px"
                @click="agreeAndNext"
                >{{ language['eletronicSigned.agreeAndNext'] }}</a-button
              >
              <!--              <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>-->
            </div>
          </div>
          <div v-else-if="processModel.modelCode === 'cst_interrupt_confirm' && model.task_code === 'Operator'">
            <a-row>
              <a-textarea v-model="model.comments" maxlength="200"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <a-button
                style="color: blue; left: 20px; padding-left: 30px; padding-right: 30px"
                @click="agreeAndNext"
                >{{ language['eletronicSigned.agreeAndNext'] }}</a-button
              >
              <!--              <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>-->
            </div>
          </div>
          <div v-else-if="processModel.modelCode === 'cst_interrupt_recovery' && model.task_code === 'FireResponsible'">
            <a-row>
              <a-textarea v-model="model.comments" maxlength="200"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <a-button
                style="color: blue; left: 20px; padding-left: 30px; padding-right: 30px"
                @click="agreeAndNext"
                >{{ language['eletronicSigned.agreeAndNext'] }}</a-button
              >
              <!--              <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>-->
            </div>
          </div>
          <div v-else-if="processModel.applicationCode === 'ipsystbs'">
            <span style="color: #6200ff">{{ language['ipsystbs.signingAlter'] }}</span>
            <a-row>
              <a-textarea v-model="model.comments" maxlength="300"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <a-button
                style="color: blue; left: 20px; padding-left: 30px; padding-right: 30px"
                @click="agreeAndNext"
                >{{ language['eletronicSigned.agreeAndNext'] }}</a-button
              >
              <a-button style="color: red; left: 40px; padding-left: 30px; padding-right: 30px" @click="reject">{{
                language['eletronicSigned.reject']
              }}</a-button>
            </div>
          </div>
          <div v-else>
            <a-row>
              <a-textarea v-model="model.comments"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <a-button
                style="color: blue; left: 20px; padding-left: 30px; padding-right: 30px"
                @click="agreeAndNext"
                >{{ language['eletronicSigned.agreeAndNext'] }}</a-button
              >
              <a-button style="color: red; left: 40px; padding-left: 30px; padding-right: 30px" @click="reject">{{
                language['eletronicSigned.reject']
              }}</a-button>
            </div>
          </div>
        </a-card>
        <!--<a-card v-if="showAllApprover" :loading="loading" :bordered="false" title="签核人" :style="{ marginTop: '24px' }">
          <a-table :columns="approverColumns" size="middle"
                   :data-source="approverData" :pagination="false" :loading="loading" ></a-table>
        </a-card>-->
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import ATextarea from 'ant-design-vue/es/input/TextArea'
// import {epm_agree} from '../auditJS/agree'
import { agree } from '@/views/static/UnifiedSignedAuditJS/agree'
import { reject } from '@/views/static/UnifiedSignedAuditJS/reject'

import JFilePop from '@/components/jeecg/minipop/JFilePop'



export default {
  name: 'UnifiedSignedTodo',
  components: {
    ATextarea,
    JInput,
    JFilePop,

  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    const { language } = this.$store.getters
    return {
      // fileUrls:["http://10.134.130.115:9000/plattest/temp/1_1640403353336.jpg","http://10.134.130.115:9000/plattest/temp/2_1640403353336.jpg"],
      urlType: '',
      fileUrls: [],
      ipsys_aid: '',
      formCode: '',
      taskCode: '',
      orderNo: '',
      pageType: 'myTodo',
      setEdit: true,
      innerFullscreen: true,
      tabName: '',
      singTableName:language['eletronicSigned.signList'],
      epDanger: {},
      dateFormat: 'YYYY-MM-DD',
      showAllApprover: true,
      isDisabled: true,
      processChartPrefix: '',
      processChartSuffix: '',
      processGuid: '',
      loading: true,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      confirmLoading: false,
      approverData: [
        /*{
          key: '10',
          approverOrgLevelNo: 'John Brown',
          approverName: 32,
          approverEmail: 'New York No. 1 Lake Park',
        },*/
      ],
      dataSource: [
        /*{
          key: '1',
          taskTextLocalLang: '隐患单（A）',
          approverName: 'W0105000',
          approveResult: '同意',
          approveComments: '你说的都对',
          approveDate: '2021-10-11',
        },
        */
      ],
      process_guid: '',
      url: {
        loadApproveResult: '/sys/wfapi/loadApproveResultGet', //获取签核记录
        getAllTaskApproversInfo: '/sys/wfapi/getAllTaskApproversInfo', //获取所有签核人
        loadEpDangerInfo: '/epm/publicApi/loadEpDangerInfoByFormNo',
      },
      processModel: {},
      fileAttribute: {
        fileMultiple: true,
        fileDisabled: false,
        number: 1,
      },
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    columns() {
      if (this.language) {
        return [
          {
            title: this.language['eletronicSigned.taskText'],
            align: 'center',
            dataIndex: 'taskTextLocalLang',
            width: 120,
          },
          {
            title: this.language['eletronicSigned.signPerson'],
            align: 'center',
            width: 100,
            dataIndex: 'approverName',
          },
          {
            title: this.language['eletronicSigned.signResult'],
            align: 'center',
            width: 80,
            dataIndex: 'approveResult',
            scopedSlots: { customRender: 'approveResult' },
            /*customRender: function (text, r, index) {
              if (text === 'Cancel') {
                // return this.language['eletronicSigned.termination']
                return this.getLanguage('eletronicSigned.termination')
              } else {
                return r.actionTextLocalLang;
              }
            }*/
          },
          {
            title: this.language['eletronicSigned.signOpinion'],
            align: 'center',
            width: 80,
            dataIndex: 'approveComments',
          },
          {
            title: this.language['eletronicSigned.signDate'],
            align: 'center',
            width: 100,
            dataIndex: 'approveDate',
          },
        ]
      }
    },
    approverColumns() {
      if (this.language) {
        return [
          {
            title: this.language['eletronicSigned.taskText'],
            align: 'center',
            dataIndex: 'taskTextLocalLang',
          },
          {
            title: this.language['eletronicSigned.signPersonWorkNo'],
            align: 'center',
            dataIndex: 'approverCode',
          },
          {
            title: this.language['eletronicSigned.signPerson'],
            align: 'center',
            dataIndex: 'realname',
          },
          {
            title: this.language['eletronicSigned.signPersonMail'],
            align: 'center',
            dataIndex: 'email',
          },
        ]
      }
    },
    formDisabled() {
      return this.disabled
    },
  },

  created() {
    let formNo = this.$route.query.formNo
    this.urlType = this.$route.query.urlType
    this.initPageData(formNo)
    /*let formNo = this.$route.query.formNo
    let nextFormNo = this.$route.query.nextFormNo
    let queryParam ={
      isWithdrawn:"0",
      model_guid:"",
      create_user_name:"",
      business_form_no:formNo,
      // application_code:this.$store.getters.applicationCode,
      // userCode: "W0888888",
      userCode:this.$store.getters.userInfo.userType==='employee'?this.$store.getters.userInfo.workNo:this.$store.getters.userInfo.username,
      taskListType: "AllToDo",
    }
    if(formNo){
        getAction("/sys/wfapi/getTaskList",queryParam).then(res=>{
          if(res.success){
            let records = res.result.records;
            if(records.length>0){
              this.edit(records[0]);
            }
          }
        })
    }*/
    getAction('/sys/wfapi/getProcessChart', {}).then((res) => {
      if (res.success) {
        this.processChartPrefix = res.result.prefix
        this.processChartSuffix = res.result.suffix
      }
    })
  },

  methods: {
    initPageData(formNo) {
      let queryParam = {
        isWithdrawn: '0',
        model_guid: '',
        create_user_name: '',
        business_form_no: formNo,
        // application_code:this.$store.getters.applicationCode,
        // userCode: "W0888888",
        userCode:
          this.$store.getters.userInfo.userType === 'employee'
            ? this.$store.getters.userInfo.workNo
            : this.$store.getters.userInfo.username,
        taskListType: 'AllToDo',
      }
      console.log('queryParam:' + queryParam)
      if (formNo) {
        getAction('/sys/wfapi/getTaskList', queryParam).then((res) => {
          if (res.success) {
            let records = res.result.records
            if (records.length > 0) {
              this.setEdit = true
              this.edit(records[0])
            }
          }
        })
      }
    },
    handleChange(file) {
      let filemap = {}
      let detileList = []
      if (file) {
        this.fileUrls = file.split(',')
        file.split(',').forEach((item, index) => {
          let map = {}
          map.fileName = item.substring(item.lastIndexOf('/') + 1)
          map.sort = index
          map.filePath = item
          detileList.push(map)
        })
      }
      filemap.pfBpmFileDetailList = detileList
      this.model.file = filemap
    },
    changeTabs(activeKey) {
      if (activeKey != '1') {
        this.showAllApprover = false
      } else {
        this.showAllApprover = true
      }
    },
    getAllTaskApproversInfo(processGuid) {
      this.loading = true
      let formData = {
        processGuid: processGuid,
      }
      postAction(this.url.getAllTaskApproversInfo, formData)
        .then((res) => {
          if (res.success) {
            const result = res.result
            this.approverData = result.map((v, i) => {
              v.key = i + 1
              return v
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    loadApproveResult(bussinessFormNo) {
      this.loading = true
      let formData = {
        formNo: bussinessFormNo,
        process_guid: this.process_guid,
      }
      getAction(this.url.loadApproveResult, formData)
        .then((res) => {
          if (res.success) {
            const result = res.result
            this.dataSource = result.map((v, i) => {
              v.key = i + 1
              return v
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    getProcessChart() {
      let processGuid = this.model.process_guid
      return this.processChartPrefix + processGuid + this.processChartSuffix + '?timestamp=' + new Date().getTime()
    },
    agreeAndNext() {
      this.agree(1)
    },
    //同意
    agree(isNext) {
      /*let map = {};
      map.pfBpmProcessId = this.model.process_guid;
      map.comments = this.model.comments;
      map.workNo = this.$store.getters.userInfo.workNo;
      map.approveAction = "Agree";
      map.taskCode = this.model.task_code;
      this.confirmLoading = true;
      getAction("/sys/wfapi/pageToRunProcess", map).then((res) => {
        if (res.success) {
          this.$emit('close');
          this.confirmLoading = false;
        }
      })*/
      let modelCode = this.processModel.modelCode
      if (
        modelCode === 'cst_high' ||
        modelCode === 'cst_hoisting' ||
        modelCode === 'cst_confined_space' ||
        modelCode === 'cst_temporary_electricity'
      ) {
        let validateResult = this.$refs.applicationModel.validateSiteSurvey(modelCode)
        if (validateResult !== 'success') {
          this.$message.warning(validateResult)
          return
        }
      }

      if (modelCode === 'cst_check') {
        let checkApprovedCallbackBefore = this.$refs.applicationModel.checkApprovedCallbackBefore()
        if (checkApprovedCallbackBefore != '') {
          this.$message.warning(checkApprovedCallbackBefore)
          return
        }
      }

      if (modelCode === 'labor_change') {
        let checkEvaluate = this.$refs.applicationModel.checkEvaluate()
        if (checkEvaluate != '') {
          this.$message.warning(checkEvaluate)
          return
        }
        if (
          this.taskCode == 'FactoryLaborAdmin' ||
          this.taskCode == 'Electromechanical' ||
          this.taskCode == 'Fire' ||
          this.taskCode == 'Environment'
        ) {
          this.agreeBack()
        } else {
          this.isAgree()
        }
      } else {
        // ---------------------------- 原始邏輯 ----------------------------
        if (this.processModel.modelCode === 'cst_flame' || this.processModel.modelCode === 'cst_gas') {
          this.agreeBack()
        } else {
          this.isAgree(isNext)
        }
        // ---------------------------- 原始邏輯 ----------------------------
      }
    },

    isAgree(isNext) {
      agree(this.processModel.applicationCode, this, isNext)
    },
    async agreeBack(modelGuid, isNext) {
      await this.$refs.applicationModel.submitForm()
      this.agreeNext(modelGuid, isNext)
    },
    agreeNext(modelGuid, isNext) {
      let that = this
      if (!!isNext && isNext == '1') {
        let username = that.$store.getters.userInfo.workNo
        getAction('/sys/electronic-signed/unifiedSigned/getFirstTodoFormNo', {
          username: username,
          modelGuid: modelGuid,
        }).then((res) => {
          if (res.success) {
            let nextFrom = res.result
            if (!!nextFrom) {
              that.initPageData(nextFrom)
              that.setEdit = true
              that.urlType == 'todoProcess'
              // that.model.comments = ''
              that.$set(that.model, 'comments', '')
            } else {
              that.setEdit = false
              that.urlType == 'flishProcess'
            }
          }
        })
      }
    },
    //驳回
    reject() {
      /*let map = {};
      map.pfBpmProcessId = this.model.process_guid;
      map.comments = this.model.comments;
      map.workNo = this.$store.getters.userInfo.workNo;
      map.approveAction = "Reject";
      map.taskCode = this.model.task_code;
      if(map.comments===null||map.comments===''||map.comments===undefined){
        this.$message.warning("驳回信息不能为空！");
        return;
      }
      this.confirmLoading = true;
      getAction("/sys/wfapi/pageToRunProcess", map).then((res) => {
        if (res.success) {
          this.$emit('close');
          this.confirmLoading = false;
        }
      })*/
      let boo = reject(this.processModel.applicationCode, this)
      if (boo) {
        // this.$refs.applicationModel.submitForm('reject');
      }
    },
    /*add() {
      this.edit(this.modelDefault);
    },*/

    edit(record) {
      // this.setEdit = record.setEdit!==null&&record.setEdit!==''&&record.setEdit!==undefined?record.setEdit:false;
      this.model = Object.assign({}, record)
      this.visible = true
      this.process_guid = this.model.process_guid
      if (record.model_code == 'HiddenDangerForm') {
        this.tabName = this.language['eletronicSigned.dangerTabName']
        this.formCode = 'HiddenDangerForm'
        this.getMode(record)
      } else if (record.model_code == 'DelayForm') {
        this.tabName = this.language['eletronicSigned.deferTabName']
        this.formCode = 'DelayForm'
        this.getMode(record)
      } else if (record.model_code == 'IpsTrademarkUserReport') {
        this.tabName = this.language['eletronicSigned.IpsTrademarkUserReportTabName']
        this.formCode = 'IpsTrademarkUserReport'
        this.getMode(record)
      } else if (record.model_code == 'IpsTrademarkUserReportC') {
        this.tabName = this.language['eletronicSigned.IpsTrademarkUserReportTabName']
        this.formCode = 'IpsTrademarkUserReportC'
        this.getMode(record)
      } else if (record.model_code == 'IpsTechnologProposal') {
        this.tabName = this.language['ElectronicSigned.technologyDisclosureCase']
        this.formCode = record.model_code
        this.getMode(record)
      } else if (record.model_code == 'IpsTechnicalBusinessSecrets') {
        this.tabName = this.language['ElectronicSigned.TechnicalBusinessSecrets']
        this.formCode = record.model_code
        this.getMode(record)
      } else if (
        record.model_code == 'IpsTechnologyDisclosureEvaluate' ||
        record.model_code == 'IpsTechnologyDisclosureEvaluateB'
      ) {
        this.tabName = this.language['ElectronicSigned.technologyDisclosureEvaluate']
        this.singTableName=this.language['eletronicSigned.tecApplysignInfor']
        this.formCode = record.model_code
        this.getMode(record)
      } else if (record.model_code == 'IpsTrademarkApplyRegister') {
        this.tabName = this.language['eletronicSigned.IpsTrademarkUserReportTabName']
        this.formCode = 'IpsTrademarkApplyRegister'
        this.getMode(record)
      }else if (record.model_code == 'IpsTrademarkRetrieve') {
        this.tabName = this.language['ipsys.easyQuery']
        this.formCode = 'IpsTrademarkRetrieve'
        this.getMode(record)
      }else if (record.model_code == 'waterForm') {
        this.tabName = this.language['eletronicSigned.waterFormTabName']
        this.formCode = 'waterForm'
        this.getMode(record)
      } else if (record.model_code == 'wasteWaterForm') {
        this.tabName = this.language['eletronicSigned.wasteWaterForm']
        this.formCode = 'wasteWaterForm'
        this.getMode(record)
      } else if (record.model_code == 'cfForm') {
        this.tabName = this.language['eletronicSigned.envinfoCfForm']
        this.formCode = 'cfForm'
        this.getMode(record)
      } else if (record.model_code == 'gasForm') {
        this.tabName = this.language['eletronicSigned.gasFormTabName']
        this.formCode = 'gasForm'
        this.getMode(record)
      } else if (record.model_code == 'trashForm') {
        this.tabName = this.language['eletronicSigned.trashFormTabName']
        this.formCode = 'trashForm'
        this.getMode(record)
      } else if (record.model_code == 'SweepDelayForm') {
        this.tabName = this.language['eletronicSigned.SweepDelayTabName']
        this.formCode = 'SweepDelayForm'
        this.getMode(record)
      } else if (record.model_code == 'SweepHiddenDangerForm') {
        this.tabName = this.language['eletronicSigned.SweepHiddenDangerTabName']
        this.formCode = 'SweepHiddenDangerForm'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiForm') {
        this.tabName = this.language['esg.kpi.update']
        this.formCode = 'esg_kpiForm'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiForm_outLeader') {
        this.tabName = this.language['esg.kpi.update']
        this.formCode = 'esg_kpiForm_outLeader'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisForm') {
        this.tabName = this.language['esg.cancleKpi']
        this.formCode = 'esg_kpiDisForm'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBgChange') {
        this.tabName = this.language['esg.kpiDisBgChange']
        this.formCode = 'esg_kpiDisBgChange'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBuChange') {
        this.tabName = this.language['esg.kpiDisBuChange']
        this.formCode = 'esg_kpiDisBuChange'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBgCancle') {
        this.tabName = this.language['esg.kpiDisBgCancle']
        this.formCode = 'esg_kpiDisBgCancle'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBuCancle') {
        this.tabName = this.language['esg.kpiDisBuCancle']
        this.formCode = 'esg_kpiDisBuCancle'
        this.getMode(record)
      } else if (record.model_code == 'labor_change') {
        this.tabName = this.language['labor.change.newApply'] //'變更申請';
        this.formCode = 'labor_change'
        this.getMode(record)
      } else if (record.model_code == 'labor_change_close') {
        this.tabName = this.language['labor.change.closeApply'] //'結案申請';
        this.formCode = 'labor_change_close'
        this.getMode(record)
      } else if (record.model_code == 'showroom_order') {
        this.tabName = 'showroom参访' //'showroom参访';
        this.formCode = 'showroom_order'
        this.getMode(record)
      } else if (record.model_code == 'cst_apply') {
        this.tabName = this.language['cst.requestOrder']
        this.formCode = 'cst_apply'
        this.getMode(record)
      } else if (record.model_code == 'cst_delay') {
        this.tabName = this.language['cst.delayRequestOrder']
        this.formCode = 'cst_delay'
        this.getMode(record)
      } else if (record.model_code == 'cst_report') {
        this.tabName = this.language['cst.reportOrder']
        this.formCode = 'cst_report'
        this.getMode(record)
      } else if (record.model_code == 'cst_night') {
        this.tabName = this.language['cst.nightOrder']
        this.formCode = 'cst_night'
        this.getMode(record)
      } else if (record.model_code == 'cst_survey') {
        this.tabName = this.language['cst.surveyCheckOrder'] + '-' + this.language['cst.surveyProcess']
        this.formCode = 'cst_survey'
        this.getMode(record)
      } else if (record.model_code == 'cst_check') {
        this.tabName = this.language['cst.surveyCheckOrder'] + '-' + this.language['cst.checkProcess']
        this.formCode = 'cst_check'
        this.getMode(record)
      } else if (record.model_code == 'cst_interrupt') {
        this.tabName = this.language['cst.interruptOrder']
        this.formCode = 'cst_interrupt'
        this.getMode(record)
      } else if (record.model_code == 'cst_interrupt_confirm') {
        this.tabName = this.language['cst.interruptOrder'] + '-' + this.language['cst.interruptProcess']
        this.formCode = 'cst_interrupt_confirm'
        this.getMode(record)
      } else if (record.model_code == 'cst_interrupt_recovery') {
        this.tabName = this.language['cst.interruptOrder'] + '-' + this.language['cst.recoveryProcess']
        this.formCode = 'cst_interrupt_recovery'
        this.getMode(record)
      } else if (record.model_code == 'cst_flame') {
        this.tabName = this.language['cst.flameContructDailyOrder']
        this.formCode = 'cst_flame'
        this.getMode(record)
      } else if (record.model_code == 'cst_gas') {
        this.tabName = this.language['cst.gas.order']
        this.formCode = 'cst_gas'
        this.getMode(record)
      } else if (record.model_code == 'cst_exception') {
        this.tabName = this.language['Abnormal.list.project.not.started'] //'未开工异常单审批流程'
        this.formCode = 'cst_exception'
        this.getMode(record)
      } else if (record.model_code == 'cst_high') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialHighOrder']
        this.formCode = 'cst_high'
        this.getMode(record)
      } else if (record.model_code == 'cst_hoisting') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialHoistingOrder']
        this.formCode = 'cst_hoisting'
        this.getMode(record)
      } else if (record.model_code == 'cst_confined_space') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialCsOrder']
        this.formCode = 'cst_confined_space'
        this.getMode(record)
      } else if (record.model_code == 'cst_temporary_electricity') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialTeOrder']
        this.formCode = 'cst_temporary_electricity'
        this.getMode(record)
      } else if (record.model_code == 'cst_carry') {
        this.tabName = this.language['construct.deviceCarry'] + '-' + this.language['common.apply']
        this.formCode = 'cst_carry'
        this.getMode(record)
      } else if (record.model_code == 'AuditWorkflow') {
        this.tabName = this.language['food.audit'] + '-' + this.language['common.apply']
        this.formCode = 'AuditWorkflow'
        this.getMode(record)
      } else if (record.model_code == 'PutOnRecordWorkflow') {
        this.tabName = this.language['food.scba'] + '-' + this.language['common.apply']
        this.formCode = 'PutOnRecordWorkflow'
        this.getMode(record)
      }

      this.loadApproveResult(this.model.business_form_no)
      this.getAllTaskApproversInfo(this.model.process_guid)
      this.loadFile(this.model.process_guid)
      // this.loadEpDangerInfo(this.model.business_form_no, this.model.model_code);
    },
    //加载附件
    loadFile(processGuid) {
      getAction('/sys/processSigned/pfBpmFile/queryByProcessGuid?processGuid=' + processGuid).then((res) => {
        if (res.success) {
          this.fileUrls = []
          let data = res.result
          data.pfBpmFileDetailList.forEach((item) => {
            this.fileUrls.push(item.filePath)
          })
          this.model.file = data
        }
      })
    },
    //查询对应的流程model
    getMode(record) {
      if (record.model_guid) {
        getAction('/sys/processSigned/pfBpmModel/queryBymodelGuId?modelGuId=' + record.model_guid, {}).then((res) => {
          if (res.success) {
            this.processModel = res.result
            this.ipsys_aid = record.business_form_no
            this.taskCode = record.task_code

            let params = {
              processGuid: this.process_guid,
              taskCode: this.taskCode,
              workNo: this.$store.getters.userInfo.workNo,
            }
            getAction('/sys/wfapi/getTaskApproversSetting', params).then((res) => {
              if (res.success) {
                this.orderNo = res.result
              }
            })
            /*if(res.result.applicationCode === 'env_audit'){
              this.ipsys_aid = record.business_form_no;
            }else if(res.result.applicationCode === 'ipsys'){
              this.ipsys_aid = record.business_form_no;
            }*/
          }
        })
      }
    },
    //根据业务单号查询
    loadEpDangerInfo(business_form_no, model_code) {
      let param = {
        formNo: business_form_no,
        modelCode: model_code,
      }
      getAction(this.url.loadEpDangerInfo, param).then((res) => {
        if (res.success) {
          const data = res.result
          this.epDanger = data
          /*if(model_code === "DelayForm"){
            getAction(this.url.loadEpDangerInfo,{formNo:data.dangerNo,modelCode:"HiddenDangerForm"}).then(res=>{
              if (res.success) {
                /!*this.epDanger.dangerDescription = res.result.dangerDescription
                this.epDanger.dangerLevel = res.result.dangerLevel
                this.epDanger.dangerAddress = res.result.dangerAddress*!/
                data.dangerDescription = res.result.dangerDescription
                data.dangerLevel = res.result.dangerLevel
                data.dangerAddress = res.result.dangerAddress
                this.epDanger = data;
              }
            })
          }else{
            this.epDanger = data;
          }*/
        }
      })
    },

    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.language['warning.pleaseUploadImage'])
        return false
      }
      //TODO 验证文件大小
    },
  },
}
</script>